// 消息推送
import Bussiness from 'Utils/business'
import { saveAppTsInfo } from 'Utils/publicApi'
import { localget , localset} from 'Utils/storage.js'

/**
 * 获取 @clientid 客户端标识
 * 调取接口@saveAppTsInfo 保存@clientid
 * */ 
export const getClientid = () => {
  console.log('addEventListener推送plusready')
  setTimeout(() => {
    console.log('推送plusready')
    // 页面加载时触发
    var pinf = plus.push.getClientInfo()
    console.log('clientid', pinf)
    var cid = pinf.clientid ||'' //客户端标识
    if (localget('access_token')) {
      saveAppTsInfo(cid)
    }
  },20000)
}

/**
 * 添加推送消息事件监听器
 */
export const push = () => {
  // plus.runtime.setBadgeNumber(1)
  // 在程序运行时接收到的消息在系统消息中心显示
  plus.push.setAutoNotification(true)
  //监听系统通知栏消息点击事件   
  //用户点击推送消息事件：一般在App后台运行时（消息通过厂商方式以通知形式在通知栏送达），然后用户点击消息后触发此事件
  plus.push.addEventListener('click', clickMessage, false)
  //iOS平台创建本地消息也会触发监听的"receive"事件，此时需要添加特殊参数来标识本地创建的消息。
  // 监听在线消息事件  
  //监听接收透传消息事件  
  //用户接收到推送消息事件：一般在用户正在使用App时（消息通过个推方式送达），用户直接在App内接收到消息并触发此事件
  plus.push.addEventListener('receive', receiveMessage, false)
  console.log('准备接受消息')
}

/**
 * 点击了通知栏消息 click 回调
 * */ 

export const clickMessage = msg => {
  console.log('点击了通知栏消息')
  //处理点击消息的业务逻辑代码
  try {
    console.log(msg)
    if (msg.payload) {
      if(typeof (msg.payload)== 'string'){
        msg.payload = JSON.parse(msg.payload)
      }
      clearMessage()
      if (msg.payload.yycj == 1) {//订单
        Bussiness.toOrderDetail({ id: msg.payload.orderId, orderType: msg.payload.orderType })
      } else if (msg.payload.yycj == 1){//审批
        Bussiness.toApproval(msg.payload)
      }
    }
  } catch (error) {
    plus.nativeUI.alert(error)
  }
}

/**
 * 用户直接在App内接收到消息并触发此事件
 * */ 
export const receiveMessage = msg => {
  console.log('用户直接在App内接收到消息并触发此事件',msg)
  //处理透传消息的业务逻辑代码  
  if ( msg.aps ) {  // Apple APNS message  
    //APNS下发的消息，应用在前台
    console.log('IOS APNS下发的消息，应用在前台')
    try {
      console.log(msg)
      if (msg.payload) {
        if(typeof (msg.payload)== 'string'){
          msg.payload = JSON.parse(msg.payload)
        }
        clearMessage()
        if (msg.payload.yycj == 1) {//订单
          Bussiness.toOrderDetail({ id: msg.payload.orderId, orderType: msg.payload.orderType })
        } else if (msg.payload.yycj == 1){//审批
          Bussiness.toApproval(msg.payload)
        }
      }
    } catch (error) {
      plus.nativeUI.alert(error)
    }
  } else if (msg.payload&&msg.payload.indexOf('LocalMSG')>-1) {   // 特殊payload标识本地创建的消息  
    //本地创建的消息，通常不需要处理  
    //注意：不要在这种情况下再此调用plus.push.createMessage，从而引起循环创建本地消息 
    console.log('本地创建的消息')
    try {
      msg.payload = msg.payload.split('*')[1]
      console.log(msg)
      if (msg.payload) {
        if(typeof (msg.payload)== 'string'){
          msg.payload = JSON.parse(msg.payload)
        }
        clearMessage()
        if (msg.payload.yycj == 1) {//订单
          Bussiness.toOrderDetail({ id: msg.payload.orderId, orderType: msg.payload.orderType })
        } else if (msg.payload.yycj == 1){//审批
          Bussiness.toApproval(msg.payload)
        }
      }
    } catch (error) {
      plus.nativeUI.alert(error)
    }
  } else {
    //接收到在线透传消息 
    console.log('User pressed!')
    //接收到在线透传消息
    console.log('接收到在线透传消息')
    console.log(msg.payload)
    localset('msgpayload',msg)
    if (typeof (msg.payload) == 'string') {
      plus.push.createMessage(msg.content, 'LocalMSG*' + msg.payload, { title: msg.title })
    } else {
      msg.payload = JSON.stringify(msg.payload)
      plus.push.createMessage(msg.content, 'LocalMSG*' + msg.payload, { title: msg.title })
    }
  }
}


/**
 * 清空消息 清空所有推送消息  
 */
export const clearMessage = () => {
  if (plus.os.name.toLowerCase() == 'ios') {
    //导入ios UIApplication    
    var UIApplication = plus.ios.import('UIApplication')
    // eslint-disable-next-line no-unused-vars
    var app = UIApplication.sharedApplication()
    //获取应用图标的数量
    var oldNum = app.applicationIconBadgeNumber()
    var newNum = oldNum - 1
    console.log('ios消息数量'+newNum)
    //设置应用图标的数量
    plus.runtime.setBadgeNumber(0)
    //导入个推原生类
    var GeTuiSdk = plus.ios.importClass('GeTuiSdk')
    GeTuiSdk.setBadge(0)
  } else {
    plus.push.clear()
  }
}

/**
 * 清空消息 清空所有推送消息
 * @msg  要删除的消息对象，可通过getAllMessage()方法来获取消息
 */
export const removeMessage =(msg)=>{
  // 删除系统消息中心指定的推送消息，可通过getAllMessage方法获取所有的消息后进行操作。
  plus.push.remove(msg)
}

/**
 * 创建本地消息
 * @options Object { cover:'Boolen' } 是否覆盖消息
 * @str String 消息内容
 */
export const createMessage =(options,str)=>{
  Object.assign(options,{cover:false})
  // str += ': 欢迎使用Html5 Plus创建本地消息！'
  plus.push.createMessage(str, 'LocalMSG', options)
}

/**
 * 获取所有消息
 */
export const getAllMessage=()=>{
  // 可以调用plus.push.getAllMessage获取系统通知栏中属于当前应用的所有消息，示例代码如下：
  var msgs = plus.push.getAllMessage()
  for(var i in msgs){
    var msg = msgs[i]
    console.log( i+': '+msg.title+' - '+msg.content )
  }
  // iOS平台不支持获取系统通知栏消息，返回空数组。
}
